import { render, staticRenderFns } from "./emolument.vue?vue&type=template&id=b8cfaac8"
import script from "./emolument.vue?vue&type=script&lang=js"
export * from "./emolument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports